import {
    apiRequest,
    angkaKreditList,
    angkaKreditInactive,
    angkaKreditTotal
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", angkaKreditList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", angkaKreditInactive, {
            body: query
        }, true)
    }

    fetchTotal = async (query, cancelToken) => {
        return await apiRequest("get", angkaKreditTotal, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository